app.controller('BrowseProductIndividualCurvedController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;


    const productModel = $rootScope.factory.product_curved.getModel(navigationIDs);

    $scope.product = productModel.product;
    productModel.apiRequire(function () {
        $scope.product = productModel.product;
    })

    $scope.product = null;

    const documentProductTag = "door_curved";

    $scope.product_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([navigationIDs.site_range_id, documentProductTag], function (documents) {
        $scope.product_document = documents.length > 0 ? documents[0] : null;
    })


    const methodInput = $rootScope.factory.tile.getModel(navigationIDs);

    const tileChoiceList = methodInput.choiceList();
    $scope.tile_choice = null;
    $scope.primary_product_choice_list = [];
    $scope.accessory_product_choice_list = [];
    for (let i = 0; i < tileChoiceList.length; i++) {
        const productChoice = tileChoiceList[i];
        if (productChoice.id === navigationIDs.tile_id) {
            $scope.tile_choice = productChoice;
            continue;
        }
        if (productChoice.parent_category_id === "curved_door") {
            $scope.primary_product_choice_list.push(productChoice);
        } else if (productChoice.parent_category_id === "curved_accessory") {
            $scope.accessory_product_choice_list.push(productChoice);
        }
    }

    $scope.parent_category_id = $scope.tile_choice ? $scope.tile_choice.parent_category_id : null;

    $scope.addToCartHandler = function (validateFormCallback, product) {

        const orderLine = {

            type: "stock",
            product_code: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            colour: navigationIDs.colour_id,
            style: navigationIDs.style_id,

            height: product.height,
            width: product.width,

            rotate_grain: product.rotate_grain,


            hinge_holes: $rootScope.service.product.collectHingeHoles(product),

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name
        };

        const orderBuild = {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            lines: [orderLine]
        };

        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {
                $rootScope.service.product.resetProduct(product);
            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });
    };

}]);